<div class="l-main__contents js-fit-contents">
  <ng-content></ng-content>
</div>
